import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of, retry, tap } from 'rxjs';

import { AppFeatureFlagsService } from './app-feature-flags.service';
import { APP_FEATURE_FLAGS_HTTP_CLIENT } from './app-features-flags-http-client.token';
import { FeatureFlags } from './features.enum';

@Injectable({ providedIn: 'root' })
export class AppFeatureFlagsHttpService {
  private httpClient = inject(APP_FEATURE_FLAGS_HTTP_CLIENT);
  private appFeatureFlagsService = inject(AppFeatureFlagsService);

  fetchFeatureFlags(): Observable<{ features: FeatureFlags[] }> {
    return this.httpClient.get<{ features: FeatureFlags[] }>('/features').pipe(
      retry({ count: 5, delay: 500 }),
      tap(({ features }) => this.appFeatureFlagsService.setFeatures(features)),
      catchError(() => of({ features: [] })),
    );
  }
}
